import React from 'react'
import { Navigate, Outlet } from 'react-router-dom'
import { getAdminToken } from './Common'

const AdminPrivateRoute = () => {
    const isLoggedIn = getAdminToken()

    if (!isLoggedIn) {
        return <Navigate to="/admin/login" replace />
    }

    return <Outlet />
}

export default AdminPrivateRoute